const ITEMS = [
  "STRATEGY",
  "CREATIVITY",
  "TECHNOLOGY",
  "GROWTH",
  "AI-POWERED BRAND GROWTH",
  "MAKE YOUR NEXT MOVE",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="font-display text-sm sm:text-base font-semibold uppercase tracking-[0.3em] text-white/25 px-8">
          {item}
        </span>
        <span className="w-1.5 h-1.5 rotate-45 bg-[#6D00FF]/60" aria-hidden="true" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative border-y border-white/[0.05] py-6 overflow-hidden bg-black/40"
    aria-hidden="true"
  >
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
    <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[#050507] to-transparent" />
    <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[#050507] to-transparent" />
  </div>
);
